<app-wrapper size="xl" @enter *ngIf="jukusData$ | async; else loadingProgress" isFitWithSmallScreen="true">
  <app-content-row>
    <app-breadcrumbs
      (breadcrumbsClick)="breadcrumbsClickHandler($event)"
      [breadcrumbs]="[
        { key: 'admin', label: 'Admin機能' },
        { key: 'admin/schools', label: 'アカウント管理 - 塾・予備校' }
      ]"
    ></app-breadcrumbs>
  </app-content-row>
  <app-content-row>
    <app-card-content [showSeparator]="true">
      <app-card-content-head>
        <mat-icon class="card-content-head-icon">group</mat-icon>
        <strong class="font-bold">アカウント管理</strong>
      </app-card-content-head>
      <app-card-content-nav (menuClick)="menuClickHandler($event)" [menus]="menu"></app-card-content-nav>
      <app-wrapper size="fluid">
        <app-content-row>
          <div class="sm:text-right">
            <button mat-flat-button color="primary" (click)="addJuku()">
              <mat-icon class="">add_circle_outline</mat-icon>
              塾・予備校を登録
            </button>
          </div>
        </app-content-row>
      </app-wrapper>

      <app-content-row>
        <app-wrapper size="fluid">
          <app-content-no-data *ngIf="(jukusData$ | async)?.length === 0">
            <span>ユーザーが存在する塾・予備校がありません</span>
          </app-content-no-data>
        </app-wrapper>
        <app-wrapper size="fluid" isFitWithSmallScreen="true">
          <app-table-overflow>
            <table mat-table [dataSource]="jukusData$ | async" class="w-full">
              <ng-container matColumnDef="jukuCode">
                <th mat-header-cell *matHeaderCellDef style="min-width: 90px;">塾・予備校コード</th>
                <td mat-cell *matCellDef="let element" class="text-sm">
                  {{ element.jukuCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="jukuName">
                <th mat-header-cell *matHeaderCellDef style="min-width: 200px;">塾・予備校名</th>
                <td mat-cell *matCellDef="let element" class="text-sm">
                  <button class="text-primary underline hover:no-underline" (click)="plans(element.jukuCode)">
                    {{ getJukuName(element) }}
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="planStatus">
                <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">契約状況</th>
                <td mat-cell *matCellDef="let element" class="text-sm">
                  <div class="text-primary" *ngIf="element.planStatus === planActiveStatus">
                    <app-label-with-icon iconName="check_circle">契約中</app-label-with-icon>
                  </div>
                  <div class="text-black" *ngIf="element.planStatus === planUnassignedStatus">契約なし</div>
                  <div class="text-gray-300" *ngIf="element.planStatus === planEndedStatus">契約終了</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="manage">
                <th mat-header-cell *matHeaderCellDef>管理・編集</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-flat-button color="primary" (click)="plans(element.jukuCode)">管理・編集</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">登録情報編集</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <button mat-icon-button (click)="editJuku(element)" class="icon-button-edit" *ngIf="element.jukuCode !== otherJukuCode">
                    <mat-icon>create</mat-icon>
                  </button>
                </td></ng-container
              >

              <ng-container matColumnDef="remove">
                <th mat-header-cell *matHeaderCellDef style="text-align: center;">削除</th>
                <td mat-cell *matCellDef="let element" style="text-align: center;">
                  <button
                    mat-icon-button
                    (click)="removeJuku(element)"
                    class="icon-button-delete"
                    *ngIf="element.jukuCode !== otherJukuCode"
                  >
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </app-table-overflow>
        </app-wrapper>
      </app-content-row>
    </app-card-content>
  </app-content-row>
</app-wrapper>

<ng-template #loadingProgress>
  <div class="progress-48">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
</ng-template>
